import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";
import * as summaryReportAction from "../../../store/summary-report/action";

import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Input,
    Modal,
    Row,
    Table,
} from "reactstrap";
import {
    DELETE_RP_QUALITY,
    GET_RP_QUALITY,
    SAVE_LIST_RP_QUALITY,
    SAVE_RP_QUALITY,
} from "helpers/url_api_constant";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import BootstrapTable from "react-bootstrap-table-next";
import PropTypes from "prop-types";
import debounce from "lodash.debounce";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function SectionQuality(props) {
    // console.log(props);
    const dispatch = useDispatch();
    // const [searchDate, setSearchDate] = useState(moment(new Date().setDate(new Date().getDate() - 1)).format(
    //     "YYYY-MM-DD"));
    // const searchDate = { SELECT_DATE: props.date };

    const defaultQualityModel = {
        // PID: "",
        SUMMARYREPORT_PID: props.summaryReportPid,
        QUALITY_STATUS: 0,
        OFFSHORE_STATUS: false,
        OFFSHORE_REMARK: "",
        EAST_STATUS: false,
        EAST_REMARK: "",
        WEST_STATUS: false,
        WEST_REMARK: "",
        EASTWEST_STATUS: false,
        EASTWEST_REMARK: "",
        SOUTH_STATUS: false,
        SOUTH_REMARK: "",
        STATUS_FLAG: 0,
        DELETE_FLAG: 0,
    };
    // console.log(defaultQualityModel);

    const [qualityModel, setQualityModel] = useState(defaultQualityModel);

    useEffect(() => {
        setQualityModel(defaultQualityModel);
        fetchData();
    }, [props.summaryReportPid]);

    // useEffect(function () {
    //     // fetchData();
    //     if (qualityModel.QUALITY_STATUS == 0) {
    //         setQualityModel({ ...defaultQualityModel, SUMMARYREPORT_PID: props.summaryReportPid, });
    //     }
    // }, [qualityModel.QUALITY_STATUS]);
    const setDispatchAction = useMemo(
        () =>
            debounce((value) => {
                dispatch(
                    summaryReportAction.setQualityToState({
                        ...value,
                        // SUMMARYREPORT_PID: props.summaryReportPid,
                        OFFSHORE_STATUS: value.OFFSHORE_STATUS == true ? 1 : 0,
                        EAST_STATUS: value.EAST_STATUS == true ? 1 : 0,
                        WEST_STATUS: value.WEST_STATUS == true ? 1 : 0,
                        EASTWEST_STATUS: value.EASTWEST_STATUS == true ? 1 : 0,
                        SOUTH_STATUS: value.SOUTH_STATUS == true ? 1 : 0,
                    })
                );
            }, 300),
        []
    );
    useEffect(() => {
        // console.log(qualityModel);
        setDispatchAction(qualityModel);
    }, [qualityModel]);

    const fetchData = async () => {
        dispatch(loadingAction.showLoading());
        try {
            let res = await post(GET_RP_QUALITY, {
                SUMMARYREPORT_PID:
                    props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
            });
            // console.log(res);
            if (res.data.rpQualityList.length == 1) {
                setQualityModel(res.data.rpQualityList[0]);
            }
        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        dispatch(loadingAction.hideLoading());
    };

    return (
        <Row>
            <Col sm="12">
                <Card  className="mb-1" style={{ backgroundColor: "#001fff1f" }}>
                    <CardBody>
                        <Row>
                            <Col sm="12">
                                <Row className="mt-0">
                                    <Col sm="12">
                                        <h5
                                            className="mb-0 sm-0 font-size-18"
                                            style={{ color: "#2FA3FF" }}
                                            //#3F91FF
                                        >
                                            Quality
                                        </h5>
                                    </Col>
                                </Row>

                                <Row className="mt-2">
                                    <hr style={{ color: "#2FA3FF" }} />
                                </Row>

                                <Row className="mt-0">
                                    <Col lg="3">
                                        <div className="table-responsive">
                                            <Table className="table table-bordered mb-0">
                                                <tbody
                                                    style={{ color: "#FFFFFF", textAlign: "center" }}
                                                >
                                                    <tr>
                                                        <td colSpan={2} style={{ height: "50px" }}>
                                                            <Col sm={12}>
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="exampleRadios"
                                                                    id="normal"
                                                                    value="0"
                                                                    // defaultChecked
                                                                    checked={qualityModel.QUALITY_STATUS == 0}
                                                                    onChange={e => {
                                                                        setQualityModel((prevData) => {
                                                                            return {
                                                                                ...defaultQualityModel,
                                                                                PID: prevData.PID,
                                                                                SUMMARYREPORT_PID: props.summaryReportPid,
                                                                            }
                                                                        });
                                                                    }}
                                                                />
                                                                <label
                                                                    className="form-check-label ms-2"
                                                                    htmlFor="normal"
                                                                >
                                                                    Normal
                                                                </label>

                                                                <input
                                                                    className="form-check-input ms-5"
                                                                    type="radio"
                                                                    name="exampleRadios"
                                                                    id="abnormal"
                                                                    value="1"
                                                                    checked={qualityModel.QUALITY_STATUS == 1}
                                                                    onChange={e => {
                                                                        setQualityModel({
                                                                            ...qualityModel,
                                                                            QUALITY_STATUS: e.target.value,
                                                                        });
                                                                    }}
                                                                />
                                                                <label
                                                                    className="form-check-label ms-2"
                                                                    htmlFor="abnormal"
                                                                >
                                                                    Abnormal
                                                                </label>
                                                            </Col>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Col>

                                    <Col lg="9">
                                        <div className="table-responsive">
                                            <Table className="table table-bordered mb-0">
                                                <tbody
                                                    style={{ color: "#FFFFFF", textAlign: "center" }}
                                                >
                                                    <tr>
                                                        <td rowSpan={6} style={{ verticalAlign: "middle" }}>Detail</td>
                                                    </tr>

                                                    <tr>
                                                        <td style={{ textAlign: "left", width: "20%" }}>
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    checked={qualityModel.OFFSHORE_STATUS}
                                                                    id="Offshore"
                                                                    onChange={e => {
                                                                        setQualityModel({
                                                                            ...qualityModel,
                                                                            OFFSHORE_STATUS: e.target.checked,
                                                                        });
                                                                    }}
                                                                    disabled={qualityModel.QUALITY_STATUS == 0}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="Offshore"
                                                                >
                                                                    Offshore
                                                                </label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <Col sm={12}>
                                                                <Input
                                                                    placeholder="-"
                                                                    type="textarea"
                                                                    rows="2"
                                                                    style={{
                                                                        border: "solid 1px #FFFFFF",
                                                                        color: "#FFFFFF",
                                                                    }}
                                                                    className="form-control"
                                                                    onChange={e =>
                                                                        setQualityModel({
                                                                            ...qualityModel,
                                                                            OFFSHORE_REMARK: e.target.value,
                                                                        })
                                                                    }
                                                                    disabled={
                                                                        qualityModel.QUALITY_STATUS == 0 ||
                                                                        qualityModel.OFFSHORE_STATUS == false
                                                                    }
                                                                    value={qualityModel.OFFSHORE_REMARK}
                                                                />
                                                            </Col>
                                                        </td>
                                                    </tr>

                                                    <tr style={{ textAlign: "center" }}>
                                                        <td>
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    checked={qualityModel.EAST_STATUS}
                                                                    id="East"
                                                                    onChange={e => {
                                                                        setQualityModel({
                                                                            ...qualityModel,
                                                                            EAST_STATUS: e.target.checked,
                                                                        });
                                                                    }}
                                                                    disabled={qualityModel.QUALITY_STATUS == 0}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="East"
                                                                >
                                                                    East
                                                                </label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <Col sm={12}>
                                                                <Input
                                                                    placeholder="-"
                                                                    type="textarea"
                                                                    rows="2"
                                                                    style={{
                                                                        border: "solid 1px #FFFFFF",
                                                                        color: "#FFFFFF",
                                                                    }}
                                                                    className="form-control"
                                                                    onChange={e =>
                                                                        setQualityModel({
                                                                            ...qualityModel,
                                                                            EAST_REMARK: e.target.value,
                                                                        })
                                                                    }
                                                                    disabled={
                                                                        qualityModel.QUALITY_STATUS == 0 ||
                                                                        qualityModel.EAST_STATUS == false
                                                                    }
                                                                    value={qualityModel.EAST_REMARK}
                                                                />
                                                            </Col>
                                                        </td>
                                                    </tr>
                                                    <tr style={{ textAlign: "center" }}>
                                                        <td>
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    checked={qualityModel.WEST_STATUS}
                                                                    id="West"
                                                                    onChange={e => {
                                                                        setQualityModel({
                                                                            ...qualityModel,
                                                                            WEST_STATUS: e.target.checked,
                                                                        });
                                                                    }}
                                                                    disabled={qualityModel.QUALITY_STATUS == 0}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="West"
                                                                >
                                                                    West
                                                                </label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <Col sm={12}>
                                                                <Input
                                                                    placeholder="-"
                                                                    type="textarea"
                                                                    rows="2"
                                                                    style={{
                                                                        border: "solid 1px #FFFFFF",
                                                                        color: "#FFFFFF",
                                                                    }}
                                                                    className="form-control"
                                                                    onChange={e =>
                                                                        setQualityModel({
                                                                            ...qualityModel,
                                                                            WEST_REMARK: e.target.value,
                                                                        })
                                                                    }
                                                                    disabled={
                                                                        qualityModel.QUALITY_STATUS == 0 ||
                                                                        qualityModel.WEST_STATUS == false
                                                                    }
                                                                    value={qualityModel.WEST_REMARK}
                                                                />
                                                            </Col>
                                                        </td>
                                                    </tr>
                                                    <tr style={{ textAlign: "center" }}>
                                                        <td>
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    checked={qualityModel.EASTWEST_STATUS}
                                                                    id="EastWest"
                                                                    onChange={e => {
                                                                        setQualityModel({
                                                                            ...qualityModel,
                                                                            EASTWEST_STATUS: e.target.checked,
                                                                        });
                                                                    }}
                                                                    disabled={qualityModel.QUALITY_STATUS == 0}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="EastWest"
                                                                >
                                                                    East West
                                                                </label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <Col sm={12}>
                                                                <Input
                                                                    placeholder="-"
                                                                    type="textarea"
                                                                    rows="2"
                                                                    style={{
                                                                        border: "solid 1px #FFFFFF",
                                                                        color: "#FFFFFF",
                                                                    }}
                                                                    className="form-control"
                                                                    onChange={e =>
                                                                        setQualityModel({
                                                                            ...qualityModel,
                                                                            EASTWEST_REMARK: e.target.value,
                                                                        })
                                                                    }
                                                                    disabled={
                                                                        qualityModel.QUALITY_STATUS == 0 ||
                                                                        qualityModel.EASTWEST_STATUS == false
                                                                    }
                                                                    value={qualityModel.EASTWEST_REMARK}
                                                                />
                                                            </Col>
                                                        </td>
                                                    </tr>
                                                    <tr style={{ textAlign: "center" }}>
                                                        <td>
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    checked={qualityModel.SOUTH_STATUS}
                                                                    id="South"
                                                                    onChange={e => {
                                                                        setQualityModel({
                                                                            ...qualityModel,
                                                                            SOUTH_STATUS: e.target.checked,
                                                                        });
                                                                    }}
                                                                    disabled={qualityModel.QUALITY_STATUS == 0}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="South"
                                                                >
                                                                    South
                                                                </label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <Col sm={12}>
                                                                <Input
                                                                    placeholder="-"
                                                                    type="textarea"
                                                                    rows="2"
                                                                    style={{
                                                                        border: "solid 1px #FFFFFF",
                                                                        color: "#FFFFFF",
                                                                    }}
                                                                    className="form-control"
                                                                    onChange={e =>
                                                                        setQualityModel({
                                                                            ...qualityModel,
                                                                            SOUTH_REMARK: e.target.value,
                                                                        })
                                                                    }
                                                                    disabled={
                                                                        qualityModel.QUALITY_STATUS == 0 ||
                                                                        qualityModel.SOUTH_STATUS == false
                                                                    }
                                                                    value={qualityModel.SOUTH_REMARK}
                                                                />
                                                            </Col>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
}

SectionQuality.propTypes = {
    t: PropTypes.any,
    date: PropTypes.any,
    summaryReportPid: PropTypes.any,
};

export default SectionQuality;
